import { Injectable } from '@angular/core';

import { ChatBotInputs } from '../enums/chat-bot-inputs';

@Injectable({
    providedIn: 'root',
})
export class ChatbotService {
    public get isChatbotAvailable(): boolean {
        return 'botmanWebchatJS' in globalThis;
    }

    /**
     * Le chatbot : https://espace.agir.orange.com/x/aLrVcg
     * @param intent intention
     * @param clientData contrat
     */
    public openChatbot(intent?: string, clientData?: { cid: string }): boolean {
        if (!this.isChatbotAvailable) {
            return false;
        }

        globalThis.botmanWebchatJS.openBotmanWebchat(intent, clientData);
        return true;
    }

    /**
     * Le chatbot : https://espace.agir.orange.com/x/aLrVcg
     * @param clientData
     */
    updateContext(clientData: ChatBotInputs): boolean {
        if (!this.isChatbotAvailable) {
            return false;
        }
        globalThis.botmanWebchatJS.updateContext(clientData);
        return true;
    }
}
